import { addClass, removeClass } from 'helpers/helpers';
import { ENGT_CHAT } from 'js/bot.model';
import { badgeNumberFormatter } from '../../helpers/helpers';
import { badge, setter } from './badge.model';
import { BadgeTemplate } from './badge.template';

export default class Badge {
	constructor(props) {
		setter(props);

		this.init();
		this.html = BadgeTemplate(badge);
	}

	setBadgeCount = (id, value) => {
		if (!id) {
			return;
		}
		const element = document.getElementById(id);

		if (element) {
			if (value) {
				document.getElementById(id).innerText = badgeNumberFormatter(value);
				removeClass(document.getElementById(id), 'engt-badge-hidden');
			} else {
				document.getElementById(id).innerText = 0;
				addClass(document.getElementById(id), 'engt-badge-hidden');
			}
		}
	};

	init() {
		ENGT_CHAT.set('setBadgeCount', this.setBadgeCount);
	}

	render() {
		return this.html;
	}
}
